import { createContext, useContext, useState, type ReactNode } from 'react';

type LiveStatusContextValue = {
  connected: boolean;
  setConnected: (v: boolean) => void;
};

const LiveStatusContext = createContext<LiveStatusContextValue>({
  connected: false,
  setConnected: () => undefined,
});

export function LiveStatusProvider({ children }: { children: ReactNode }) {
  const [connected, setConnected] = useState(false);
  return (
    <LiveStatusContext.Provider value={{ connected, setConnected }}>{children}</LiveStatusContext.Provider>
  );
}

export function useLiveStatus() {
  return useContext(LiveStatusContext);
}
